import { render, staticRenderFns } from "./RulesInput.vue?vue&type=template&id=8c4f9364&scoped=true&"
import script from "./RulesInput.vue?vue&type=script&lang=js&"
export * from "./RulesInput.vue?vue&type=script&lang=js&"
import style0 from "./RulesInput.vue?vue&type=style&index=0&id=8c4f9364&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4f9364",
  null
  
)

export default component.exports